// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__15IwW","clinicsSelect":"TableHeading_clinicsSelect__1VnQm"};